import React, { useEffect } from 'react';

import { useSearchParams } from 'react-router-dom';

import { callerIdService } from '../services';

export const CallerIdInitializer: React.FC<{children: React.ReactNode}> = ({ children }) => {
  const [searchParams] = useSearchParams();
  const from = searchParams.get('m_from');
  const to = searchParams.get('m_to');

  useEffect(() => {
    if (from) {
      if (to) {
        callerIdService.setNumberCallerId(to, from);
      } else {
        callerIdService.setGlobalCallerId(from);
      }
    }
  }, [from, to]);

  return <>{children}</>;
};
